import { createTheme, withStyles } from "@material-ui/core/styles";
import Switch from '@material-ui/core/Switch';

const theme: any = createTheme({
    palette: {
        primary: {
            main: '#13293d',
        },
        secondary: {
            main: '#006494',
        }
    }
});

const SwitchBlue = withStyles({
    switchBase: {
        '&$checked': {
            color: theme.palette.primary.main,
        },
        '&$checked + $track': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    checked: {},
    track: {},
})(Switch);

export { SwitchBlue, theme };